module.exports = __webpack_public_path__ + "icon_flag-6cc7d5ce6f0c35fe10e0f05494b2aba8.svg";